import React from "react";
import { useLocation } from "react-router-dom";
import useGlobalContext from "hooks/useGlobalContext";

export interface WithLocationAndLocaleProps {
  locale?: any;
  location?: any;
}

export default function withLocationAndLocale(Component: any) {
  return function WrappedComponent(props: JSX.IntrinsicAttributes) {
    const location = useLocation();
    const { locale } = useGlobalContext();
    return <Component {...props} location={location} locale={locale} />;
  };
}
